import script from "./SelfieForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelfieForm.vue?vue&type=script&setup=true&lang=ts"

import "./SelfieForm.vue?vue&type=style&index=0&id=fbe80e18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe80e18"]])

export default __exports__